import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { XDivider, YDivider, useTheme } from '../../../irmlib/src/styles'
import { MainRouteSubRoutePage } from '../../AppControl/RoutePage'
// import { CancelButton } from 'irmlib/components/FormControls'
// import { ContainedButton } from 'irmlib/components/Controls'
import styled from 'styled-components'
import { ArrowBack } from 'irmlib/icons'
import PropTypes from 'prop-types'
import * as routePaths from '../../../navigation/routePaths'
import { useLocation, Link, useHistory } from 'react-router-dom'
import * as gdeTransactions from '../../../services/firestore/gdeTransactions'
import * as gdeTransactionsLite from '../../../services/firestore/gdeTransactionsLite'
// import BoxTable from '../../Controls/BoxTable'
import QcBoxesMaterialTable from '../../Controls/QcFileTable'
import * as constants from 'irmlib/common/constants'
import moment from 'moment'
import { defaultDateFormat } from '../../../common/constants'
import { useTranslation } from 'react-i18next'

const BoxLink = styled(Link)`
  color: ${props => props.theme.palette.primary.main};
  text-decoration: none;
  text-overflow: clip;
`

const SubTitle = styled('div')`
  color: ${(props) => props.theme.palette.primary.main};
`
const PrimaryLabel = styled('div')`
 cursor: pointer;
`

const VerticalDivider = () =>
  <YDivider height='15px' />

// const Buttons = props =>
//   <>
//     <CancelButton onClick={props.onClickCancel} />
//     <XDivider width='10px' />
//     <ContainedButton disabled={props.changeApprove} onClick={props.onClickApprove}>buttons.approve</ContainedButton>
//   </>

// Buttons.propTypes = {
//   onClickApprove: PropTypes.func,
//   onClickCancel: PropTypes.func,
//   changeApprove: PropTypes.bool
// }

// const ButtonsForApprove = props =>
//   <>
//     <CancelButton onClick={closeGeneralDialog} />
//     <XDivider width='10px' />
//     <ContainedButton id={'approveComponent'} onClick={props.approveBoxes}>buttons.approve</ContainedButton>
//   </>

// ButtonsForApprove.propTypes = {
//   approveBoxes: PropTypes.func
// }

const USER_FETCH_CHUNK = 10
const FILE_SYNC_CONCURRENCY = 8

/* eslint-disable jsdoc/require-jsdoc, jsdoc/require-param, jsdoc/require-returns, jsdoc/require-param-description -- local helpers */
async function mapWithConcurrency (items, concurrency, mapper) {
  if (!items.length) {
    return []
  }
  const results = new Array(items.length)
  let nextIndex = 0
  const worker = async () => {
    while (true) {
      const i = nextIndex++
      if (i >= items.length) {
        break
      }
      results[i] = await mapper(items[i], i)
    }
  }
  await Promise.all(Array.from({ length: Math.min(concurrency, items.length) }, () => worker()))
  return results
}

// @param {string} pathname
const parseBoxesJobRoute = (pathname) => {
  const segs = pathname.split('/').filter(Boolean)
  if (segs[0] === 'boxQualityCheck' && segs[1]) {
    return { jobId: segs[1] }
  }
  return { jobId: segs[1] || '' }
}

const hasStoredFileCount = (totalFiles) => totalFiles !== undefined && totalFiles !== null
/* eslint-enable jsdoc/require-jsdoc, jsdoc/require-param, jsdoc/require-returns, jsdoc/require-param-description */

const BoxesForQualityCheck = () => {
  const { t } = useTranslation()
  const [boxes, setBoxes] = useState([])
  const [tableLoading, setTableLoading] = useState(true)
  const [listVersion, setListVersion] = useState(0)
  const location = useLocation()
  const { jobId } = parseBoxesJobRoute(location.pathname)
  const theme = useTheme()
  const history = useHistory()

  const getSortedQcBoxList = async () => {
    const collection = await gdeTransactionsLite.getBoxesForQC(jobId)

    return [...collection.docs].sort(function (a, b) {
      const boxSrNoA = a.data().boxSrNo || a.data().boxId
      const boxSrNoB = b.data().boxSrNo || b.data().boxId
      return boxSrNoA > boxSrNoB ? 1 : -1
    }).map((doc) => {
      const data = doc.data()
      return {
        skpBoxId: doc.id,
        dataEntryUser: data.dataEntryUser,
        totalFiles: data.totalFiles,
        actionTs: data.actionTs ? moment(data.actionTs.toDate()).format(defaultDateFormat) : '',
        status: data.status,
        status1: data.status,
      }
    })
  }

  const toTableRows = (boxList, { userNameById, syncedFileCounts } = {}) => {
    const userNotFoundLabel = t('messages.userNotFound')
    const resolveEntryUser = (userId) => {
      if (userId === undefined || userId === null || userId === '') {
        return userNotFoundLabel
      }
      if (userNameById) {
        return userNameById[userId] ?? userNotFoundLabel
      }
      return userId
    }
    return boxList.map((box) => ({
      skpBoxId: box.skpBoxId,
      dataEntryUser: resolveEntryUser(box.dataEntryUser),
      fileKeyed: syncedFileCounts?.[box.skpBoxId] ?? (hasStoredFileCount(box.totalFiles) ? box.totalFiles : ''),
      actionTs: box.actionTs,
      status: box.status,
      status1: box.status1,
    }))
  }

  const fetchUserNameById = async (boxList) => {
    const userNotFoundLabel = t('messages.userNotFound')
    const uniqueUserIds = [...new Set(boxList.map((b) => b.dataEntryUser).filter(Boolean))]
    if (!uniqueUserIds.length) {
      return {}
    }
    const userNameById = {}
    const chunks = []
    for (let i = 0; i < uniqueUserIds.length; i += USER_FETCH_CHUNK) {
      chunks.push(uniqueUserIds.slice(i, i + USER_FETCH_CHUNK))
    }
    const collections = await Promise.all(chunks.map((ids) => gdeTransactions.getUserList(ids)))
    collections.forEach((collection) => {
      collection.forEach((doc) => {
        const u = doc.data()
        const name = `${u?.firstName ?? ''} ${u?.lastName ?? ''}`.trim()
        userNameById[doc.id] = name || userNotFoundLabel
      })
    })
    return userNameById
  }

  const syncMissingFileCounts = async (boxList) => {
    const missing = boxList.filter((box) => !hasStoredFileCount(box.totalFiles))
    if (!missing.length) {
      return {}
    }
    const pairs = await mapWithConcurrency(
      missing,
      FILE_SYNC_CONCURRENCY,
      async (box) => {
        const count = await gdeTransactions.syncBoxTotalFiles(jobId, box.skpBoxId)
        return [box.skpBoxId, count]
      },
    )
    return Object.fromEntries(pairs)
  }

  const fileListPath = routePaths.fileQualityCheck

  const updateBoxStatus = useCallback(async (boxId) => {
    await gdeTransactionsLite.updateBoxStatus(jobId, boxId, constants.boxStatus.qcInProcess, false, [])
  }, [jobId])

  const columns = useMemo(() => [
    {
      accessorKey: 'skpBoxId',
      header: t('tableColumns.skpBoxId'),
      size: 200,
      enableSorting: true,
      /* eslint-disable react/prop-types -- MRT Cell row */
      Cell: ({ row }) => (
        <BoxLink theme={theme} onClick={() => updateBoxStatus(row.original.skpBoxId)} to={`${fileListPath}/${jobId}/${row.original.skpBoxId}`}>
          {row.original.skpBoxId}
        </BoxLink>
      ),
      /* eslint-enable react/prop-types */
    },
    {
      accessorKey: 'dataEntryUser',
      header: t('tableColumns.entryUser'),
      enableSorting: true,
    },
    {
      id: 'fileKeyed',
      accessorKey: 'fileKeyed',
      header: t('tableColumns.fileKeyed'),
      enableSorting: true,
    },
    {
      accessorKey: 'actionTs',
      header: t('tableColumns.lastStatusChange'),
      enableSorting: true,
    },
    {
      accessorKey: 'status',
      header: t('tableColumns.status'),
      enableSorting: false,
    },
  ], [t, theme, fileListPath, jobId, updateBoxStatus])

  const SubTitleComponent = props =>
    <>
      <ArrowBack onClick={props.goBack} />
      <XDivider width='10px' />
      <SubTitle theme={theme}>{t('routeTitles.boxDetails')}</SubTitle>
      <XDivider width='10px' />
      |
      <XDivider width='10px' />
      <PrimaryLabel onClick={props.viewAllFiles}>{t('routeTitles.fileDetails')}</PrimaryLabel>

    </>

  SubTitleComponent.propTypes = {
    goBack: PropTypes.func,
    viewAllFiles: PropTypes.func,
  }

  // const openApproveModal = async () => {
  //   const jobDetails = await gdeTransactions.getJobById(jobId)

  //   if (jobDetails.data().autoTransmit === undefined || jobDetails.data().autoTransmit === 'true') {
  //     openGeneralDialog({
  //       title: 'qualityCheck.approveTransmit',
  //       message: 'qualityCheck.approveBoxesMsgForautoTransmit',
  //       buttons: <ButtonsForApprove disabled = {changeApprove} approveBoxes={() => approveBoxes(jobDetails.data())} />,
  //       translateMessage: true,
  //       closeX: true
  //     })
  //   } else {
  //     openGeneralDialog({
  //       title: 'qualityCheck.approveTransmit',
  //       message: 'qualityCheck.approveBoxesMsgForManualTransmit',
  //       buttons: <ButtonsForApprove disabled = {changeApprove} approveBoxes={() => approveBoxes(jobDetails.data())} />,
  //       translateMessage: true,
  //       closeX: true
  //     })
  //   }
  // }

  // const statusUpdateForJob = async (jobDetail) => {
  //   const collection = await gdeTransactionsLite.getBoxesForJob(jobId)
  //   const boxList = []
  //   const boxUserList = []

  //   collection.forEach((doc) => {
  //     const data = doc.data()
  //     boxList.push({
  //       boxId: data.boxId,
  //       entryUser: data.dataEntryUser,
  //       status: data.status,
  //       dataEntryUser: data.dataEntryUser,
  //       verificationUser: data.verificationUser
  //     })
  //     boxUserList.push(doc.data().dataEntryUser)
  //   })
  //   const checkReadyToTransmit = (Boxes) => {
  //     if (Boxes.status === constants.boxStatus.approved) {
  //       return Boxes.status === constants.boxStatus.approved 
  //     }
  //     if (Boxes.status === constants.boxStatus.transmitted) {
  //       return Boxes.status === constants.boxStatus.transmitted 
  //     }
  //     if (Boxes.status === constants.boxStatus.exception) {
  //       return Boxes.status === constants.boxStatus.exception
  //     }
  //   }

  //   const result = boxList.filter(checkReadyToTransmit)



  //   const transmitBoxEqual = boxList.length === 0 ? false : jobDetail.totalBoxes === result.length

  //   if (transmitBoxEqual) {
  //     const data = {
  //       jobStatus: constants.jobStatus.readyToTransmit,
  //       autoTransmitAndStatus: `${jobDetail.autoTransmit}-${constants.jobStatus.readyToTransmit}`,
  //     }
  //     await gdeTransactions.updateJob(jobId, data)
  //   }
  // }

  // const approveBoxes = async (jobDetails) => {
  //   await gdeTransactionsLite.updateBoxStatus(jobId, '', constants.boxStatus.approved, true, state.selectedBoxes).then(async () => { 
  //     await statusUpdateForJob(jobDetails)
  //     closeGeneralDialog()
  //     setRefresh(flag => !flag)
  //     if (state.boxes.length === 1) {
  //       history.push(`${routePaths.qualityCheck}`)
  //     }
  //     if (boxes.length === state.boxes.length) {
  //       history.push(`${routePaths.qualityCheck}`)
  //     }
  //   })
  // }

  // const onSelectionChange = async (rows) => {
  //   if (rows.length > 0) {
  //     setChangeApprove(false)
  //   } else {
  //     setChangeApprove(true)
  //   }
  //   setState({ selectedBoxes: rows })
  // }

  const getBoxes = async (isStale) => {
    if (!jobId) return
    setTableLoading(true)
    setBoxes([])
    try {
      const boxList = await getSortedQcBoxList()
      if (isStale()) return

      setBoxes(toTableRows(boxList))
      setTableLoading(false)

      const boxesNeedingSync = boxList.some((box) => !hasStoredFileCount(box.totalFiles))
      const [userNameById, syncedFileCounts] = await Promise.all([
        fetchUserNameById(boxList),
        boxesNeedingSync ? syncMissingFileCounts(boxList) : Promise.resolve({}),
      ])
      if (isStale()) return

      setBoxes(toTableRows(boxList, { userNameById, syncedFileCounts }))
      return boxList
    } catch {
      if (!isStale()) {
        setTableLoading(false)
      }
    }
  }

  useEffect(() => {
    let cancelled = false
    const isStale = () => cancelled
    getBoxes(isStale)
    return () => {
      cancelled = true
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- reload when job id or list refresh changes
  }, [jobId, listVersion])

  const onClickCancel = async () => {
    // history.goBack()
    history.push(routePaths.qualityCheck)
  }
  const onClickViewAllFiles = async () => {
    history.push(`${routePaths.viewAllFileQualityCheck}/${jobId}`)
  }


  return (
    <MainRouteSubRoutePage
      mainTitle='routeTitles.jobManagement'
      subTitle={<SubTitleComponent goBack={onClickCancel} viewAllFiles={onClickViewAllFiles} />}
    // buttons={<Buttons onClickApprove={openApproveModal} onClickCancel={onClickCancel} changeApprove={changeApprove} />}
    >
      <XDivider width='18px' />

      {/* <BoxTable ref={tableRef} columns= {columns} selection= {true} onSelectionChange={onSelectionChange} getPageData={getBoxes} refresh={refresh}/> */}
      <QcBoxesMaterialTable
        boxList={boxes}
        columnsList={columns}
        jobId={jobId}
        isLoading={tableLoading}
        onApproveComplete={() => setListVersion((v) => v + 1)}
      />
      <VerticalDivider />
      <VerticalDivider />
    </MainRouteSubRoutePage>
  )
}

export default BoxesForQualityCheck